import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17h4v4h-4l0 -4","key":"svg-0"}],["path",{"d":"M17 3h4v4h-4l0 -4","key":"svg-1"}],["path",{"d":"M11 19h5.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h4.5","key":"svg-2"}]]

const IconRouteSquare = createReactComponent('outline', 'route-square', 'RouteSquare', __iconNode);

export default IconRouteSquare;